/**
 * @class Cookie Storage Service
 *
 * @example
 *      var people = require('cookie-store')({ root: 'people' });
        people
            .save({lastName: 'smith' })

 */

// Thin document.cookie wrapper to allow unit testing
var Cookie = function () {
    this.get = function () {
        return document.cookie;
    };

    this.set = function (newCookie) {
        document.cookie = newCookie;
    };
};

module.exports = function (config) {
    var host = window.location.hostname;
    var secureFlag = location.protocol === 'https:';
    var validHost = host.split('.').length > 1;
    var domain = validHost ? '.' + host : null;
    if (host === 'localhost') {
        domain = 'localhost';
    }
    var defaults = {
        /**
         * Name of collection
         * @type { string}
         */
        root: '/',

        domain: domain,
        secure: secureFlag,
        cookie: new Cookie()
    };
    this.serviceOptions = $.extend({}, defaults, config);

    var publicAPI = {
        // * TBD
        //  * Query collection; uses MongoDB syntax
        //  * @see  <TBD: Data API URL>
        //  *
        //  * @param { string} qs Query Filter
        //  * @param { string} limiters @see <TBD: url for limits, paging etc>
        //  *
        //  * @example
        //  *     cs.query(
        //  *      { name: 'John', className: 'CSC101' },
        //  *      {limit: 10}
        //  *     )

        // query: function (qs, limiters) {

        // },

        /**
         * Save cookie value.  Note: root defaults to '/', domain defaults to current domain, samesite defaults to "none".
         * Secure flag is added to pages served from https.
         * @param  { string|Object} key   If given a key save values under it, if given an object directly, save to top-level api
         * @param  {any} [value] value to store
         * @param {object} [options] Overrides for service options (domain, samesite, root)
         *
         * @return {*} The saved value
         *
         * @example
         *     cs.set('person', { firstName: 'john', lastName: 'smith' });
         *     cs.set({ name:'smith', age:'32' });
         */
        set: function (key, value, options) {
            var setOptions = $.extend(true, {}, this.serviceOptions, options);

            var domain = setOptions.domain;
            var samesite = setOptions.samesite;
            var path = setOptions.root;
            var cookie = setOptions.cookie;
            var secureFlag = setOptions.secure;
            const contents = [`${encodeURIComponent(key)}=${encodeURIComponent(value)}`];
            if (domain) {
                contents.push(`domain=${domain}`);
            }
            if (path) {
                contents.push(`path=${path}`);
            }
            if (secureFlag) {
                contents.push('secure');
            }
            if (samesite) {
                contents.push(`samesite=${samesite}`);
            } else if (domain === '.local.forio.com' || domain === 'localhost') {
                contents.push('samesite=lax');
            } else {
                contents.push('samesite=none');
            }
            if (setOptions.expires !== undefined) {
                contents.push(`expires=${setOptions.expires}`);
            }
            cookie.set(contents.join('; '));

            return value;
        },

        /**
         * Load cookie value
         * @param  {string| object} key   If given a key save values under it, if given an object directly, save to top-level api
         * @return {any} The value stored
         *
         * @example
         *     cs.get('person');
         */
        get: function (key) {
            var cookie = this.serviceOptions.cookie;
            var cookieReg = new RegExp('(?:^|;)\\s*' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$');
            var res = cookieReg.exec(cookie.get());
            var val = res ? decodeURIComponent(res[1]) : null;
            return val;
        },

        /**
         * Removes key from collection
         * @param {string} key key to remove
         * @param {object} [options] overrides for service options
         * @return {string} key The key removed
         *
         * @example
         *     cs.remove('person');
         */
        remove: function (key, options) {
            var remOptions = $.extend(true, {}, this.serviceOptions, options);

            var domain = remOptions.domain;
            var path = remOptions.root;
            var cookie = remOptions.cookie;

            cookie.set(encodeURIComponent(key) +
                            '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
                            (domain ? '; domain=' + domain : '') +
                            (path ? '; path=' + path : '')
            );
            return key;
        },

        /**
         * Removes collection being referenced
         * @return {string[]} keys All the keys removed
         */
        destroy: function () {
            var cookie = this.serviceOptions.cookie;
            var aKeys = cookie.get().replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:=[^;]*)?;\s*/);
            for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
                var cookieKey = decodeURIComponent(aKeys[nIdx]);
                this.remove(cookieKey);
            }
            return aKeys;
        }
    };

    $.extend(this, publicAPI);
};



// WEBPACK FOOTER //
// ./src/store/cookie-store.js